"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserCell = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _UserInfo = require("../../../user-components/user-info/UserInfo");
var _react = _interopRequireDefault(require("react"));
var _headerCellFactory = require("../header-cell/headerCellFactory");
var _loadingCellFactory = require("../loading-cell/loadingCellFactory");
var _userCellModule = _interopRequireDefault(require("./user-cell.module.scss"));
var UserCell = function UserCell(_ref) {
  var user = _ref.data,
    className = _ref.className;
  var userName = user.userName;
  return /*#__PURE__*/_react.default.createElement("td", {
    className: (0, _classnames.default)(_userCellModule.default['user-cell'], className)
  }, userName.name && userName.surname ? /*#__PURE__*/_react.default.createElement(_UserInfo.UserInfo, {
    name: userName.name,
    surname: userName.surname,
    className: _userCellModule.default['user-cell__user-info'],
    description: user.id
  }) : user.id);
};
exports.UserCell = UserCell;
UserCell.Header = (0, _headerCellFactory.headerCellFactory)(_userCellModule.default['user-cell']);
UserCell.Loading = (0, _loadingCellFactory.loadingCellFactory)(_userCellModule.default['user-cell']);